import styled from '@emotion/styled';
import { mapStylesProp } from 'utils/styles';

export const ThUI = styled('th')(mapStylesProp);
